import axios from 'axios'
import { appServer } from './AppURL'

const request = axios.create({
  baseURL: appServer,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

export default request
